import request from '@/utils/request';

//upload
export function fileUpload(data) {
  return request({
    url: '/file/upload',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
}
//图片预览
export function previewImage(data) {
  return request({
    url: '/file/preview/image',
    method: 'get',
    params: data,
  });
}
// 上传文件
export function uploadFile(formData, params) {
  console.log(formData, 'formData in uploadFile======'); // 检查 formData 的内容
  console.log(params, 'params in uploadFile======'); // 检查 params 的内容
  return request({
    url: '/file/upload',
    method: 'post',
    data: formData, // 确保 data 参数是 formData
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data', // 确保 Content-Type 设置正确
    },
  });
}
// 上传图片
export function uploadImage(formData, params) {
  console.log(formData, 'formData in uploadFile======'); // 检查 formData 的内容
  console.log(params, 'params in uploadFile======'); // 检查 params 的内容
  return request({
    url: '/file/uploadImage',
    method: 'post',
    data: formData, // 确保 data 参数是 formData
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data', // 确保 Content-Type 设置正确
    },
  });
}
//down 下载资料
export function downFile(data) {
  return request({
    url: '/file/down',
    method: 'get',
    params: data,
    responseType: 'blob',
  });
}
//pdf预览
export function previewPdf(data) {
  return request({
    url: '/file/preview/pdf',
    method: 'get',
    params: data,
  });
}
//查询已上传资料
export function queryFileList(data) {
  return request({
    url: '/file/queryList',
    method: 'get',
    params: data,
  });
}
//查询已上传照片
export function queryImageList(data) {
  return request({
    url: '/file/queryImage',
    method: 'get',
    params: data,
  });
}
//删除文件
export function deleteFile(data) {
  return request({
    url: '/file/deleteFile',
    method: 'get',
    params: data,
  });
}
